/* Limited to the refined product-description container; safe to run repeatedly. */
(function () {
  const normalize = (text) => text.replace(/\s+/g, ' ').trim();
  const blocks = 'p,div,li,blockquote,h1,h2,h3,h4,h5,h6,td,th,section,article';
  const processed = new WeakSet();
  const media = 'img,svg,video,audio,iframe,object,embed,canvas,hr,input,button';

  window.refineProductDetailOrigin = function (container) {
    const rte = container.querySelector('.rte[data-origin-countries]');
    if (!rte || processed.has(rte)) return; // Includes the existing server-rendered origin-only case.
    const details = rte.closest('details');
    if (!details || details.parentElement !== container) return;
    const countries = JSON.parse(rte.dataset.originCountries);
    const leaves = [];
    const visit = (node) => {
      if (node.nodeType === 3) {
        if (normalize(node.textContent)) leaves.push(node);
        return;
      }
      if (node.nodeType !== 1) return;
      const style = window.getComputedStyle(node);
      if (node.hidden || node.matches('script,style,template') ||
          style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse') return;
      if (node.matches(media)) {
        leaves.push(node); // Visible non-text content also prevents trailing extraction.
        return;
      }
      node.childNodes.forEach(visit);
    };
    visit(rte);
    const last = leaves[leaves.length - 1];
    if (!last || last.nodeType !== 3) return;
    const source = last.parentElement.closest(blocks);
    if (!source || source === rte || !rte.contains(source) || source.querySelector(media)) return;
    // Match the whole standalone block, never a substring or an inline prose fragment.
    const text = normalize(source.textContent);
    const match = /^made in (.+)$/i.exec(text);
    if (!match || !countries.includes(match[1].toLowerCase())) return;

    const row = document.createElement('p');
    row.className = 'product-detail-origin';
    row.setAttribute('itemprop', 'description');
    const icon = document.createElement('i');
    icon.className = 'zmdi zmdi-flag';
    icon.setAttribute('aria-hidden', 'true');
    const label = document.createElement('span');
    label.textContent = text;
    row.append(icon, label);
    processed.add(rte);
    source.remove();
    container.querySelectorAll('.product-detail-origin').forEach((origin) => origin.remove());
    container.insertBefore(row, details);
  };
})();
